
import { Component, Vue } from "vue-property-decorator";

import LanguageResources from '@/components/utils/LanguageResources.vue';

@Component({
	components:{
		LanguageResources
	}
})
export default class NavigationFooter extends Vue {

	contactUs = false;
	languageResource = false;

	mounted() {
		this.contactUs = false;
		this.languageResource = false;
	}

	public displayTerms() {
		this.$router.push({ name: "terms" });
	}
}
